import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from '../lib/language';
export default function Benefits() {
    const { t } = useTranslation();
    const benefits = [
        {
            title: t('benefits.natural.title'),
            description: t('benefits.natural.desc'),
            icon: '🌿',
        },
        {
            title: t('benefits.tested.title'),
            description: t('benefits.tested.desc'),
            icon: '🔬',
        },
        {
            title: t('benefits.science.title'),
            description: t('benefits.science.desc'),
            icon: '📚',
        },
        {
            title: t('benefits.sustainable.title'),
            description: t('benefits.sustainable.desc'),
            icon: '♻️',
        },
    ];
    return (_jsx("section", { id: "benefits", className: "py-20 bg-white", children: _jsxs("div", { className: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8", children: [_jsxs("div", { className: "text-center mb-16", children: [_jsx("h2", { className: "text-4xl font-bold text-gray-900 mb-4", children: t('benefits.title') }), _jsx("p", { className: "text-xl text-gray-600 max-w-2xl mx-auto", children: t('benefits.subtitle') })] }), _jsx("div", { className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8", children: benefits.map((benefit, index) => (_jsxs("div", { className: "text-center", children: [_jsx("div", { className: "text-5xl mb-4", children: benefit.icon }), _jsx("h3", { className: "text-xl font-semibold text-gray-900 mb-3", children: benefit.title }), _jsx("p", { className: "text-gray-600", children: benefit.description })] }, index))) })] }) }));
}
